import { Mutex } from '../lock/mutex';

// oxlint-disable-next-line no-explicit-any
export function atomicChain<T extends (...args: any[]) => Promise<void>>(fn: T): T {
  const mutex = new Mutex();
  return ((...args) => mutex.runExclusive(() => fn(...args))) as T;
}
